// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  ProjectUserMinified,
  ProjectUserMinifiedFromJSON,
  ProjectUserMinifiedToJSON,
} from "./";

/**
 *
 * @export
 * @interface ProjectListItem
 */
export interface ProjectListItem {
  /**
   *
   * @type {number}
   * @memberof ProjectListItem
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof ProjectListItem
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ProjectListItem
   */
  description?: string;
  /**
   *
   * @type {boolean}
   * @memberof ProjectListItem
   */
  archived: boolean;
  /**
   *
   * @type {Array<ProjectUserMinified>}
   * @memberof ProjectListItem
   */
  team?: Array<ProjectUserMinified>;
  /**
   *
   * @type {string}
   * @memberof ProjectListItem
   */
  activity?: string;
  /**
   *
   * @type {string}
   * @memberof ProjectListItem
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof ProjectListItem
   */
  updatedAt: string;
  /**
   * Indicates that the project is a sample project or not
   * @type {boolean}
   * @memberof ProjectListItem
   */
  isSample?: boolean;
  /**
   * Number of test cases in the project
   * @type {number}
   * @memberof ProjectListItem
   */
  testCaseCount?: number;
  /**
   * Number of active test plans in the project
   * @type {number}
   * @memberof ProjectListItem
   */
  testPlanCount?: number;
}

export function ProjectListItemFromJSON(json: any): ProjectListItem {
  return {
    id: json["id"],
    name: json["name"],
    description: !exists(json, "description") ? undefined : json["description"],
    archived: json["archived"],
    team: !exists(json, "team")
      ? undefined
      : (json["team"] as Array<any>).map(ProjectUserMinifiedFromJSON),
    activity: !exists(json, "activity") ? undefined : json["activity"],
    createdAt: json["created_at"],
    updatedAt: json["updated_at"],
    isSample: !exists(json, "is_sample") ? undefined : json["is_sample"],
    testCaseCount: !exists(json, "test_case_count")
      ? undefined
      : json["test_case_count"],
    testPlanCount: !exists(json, "test_plan_count")
      ? undefined
      : json["test_plan_count"],
  };
}

export function ProjectListItemToJSON(value?: ProjectListItem): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    name: value.name,
    description: value.description,
    archived: value.archived,
    team:
      value.team === undefined
        ? undefined
        : (value.team as Array<any>).map(ProjectUserMinifiedToJSON),
    activity: value.activity,
    created_at: value.createdAt,
    updated_at: value.updatedAt,
    is_sample: value.isSample,
    test_case_count: value.testCaseCount,
    test_plan_count: value.testPlanCount,
  };
}
